import script from "./TempStorageView.vue?vue&type=script&setup=true&lang=js"
export * from "./TempStorageView.vue?vue&type=script&setup=true&lang=js"

import "./TempStorageView.vue?vue&type=style&index=0&id=084c2146&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-084c2146"]])

export default __exports__